import axios from '@/api/axios'

export default {
    countries: {
        getCountries: (search) => {
            let url = `/base/api/locations/countries`
            if (search) {
                url += `?search=${encodeURIComponent(search)}`
            }
            return axios.get(url).then((res) => res.data)
        },
        getCities: (countryIso2, search) => {
            let url = `/base/api/locations/${countryIso2}/cities`
            if (search) {
                url += `?search=${encodeURIComponent(search)}`
            }
            return axios.get(url).then((res) => res.data)
        },
    },
}
